import { render } from "./AdsModalComp.vue?vue&type=template&id=1de06495&scoped=true"
import script from "./AdsModalComp.vue?vue&type=script&lang=js"
export * from "./AdsModalComp.vue?vue&type=script&lang=js"

import "./AdsModalComp.vue?vue&type=style&index=0&id=1de06495&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de06495"]])

export default __exports__